function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22.131 5.56c-1.36-.454-3.506-1.147-5.733-2.64-2.226-1.493-3.2-2.92-4.4-2.92-1.186 0-2.159 1.44-4.385 2.933C5.386 4.426 3.24 5.106 1.88 5.573.507 6.013 0 5.586 0 8.359c0 6.413 2.826 11.812 3.533 13.132 1.746 3.6 3.733 6.786 4.973 6.96 1.24.173 5.56-4.627 7.999-9.946.867-1.787 1.44-3.693 1.64-5.36v-.053c.027-.213.04-.427.053-.64v-.027c0-.106.013-.213.013-.32.054-2.066-.586-3.546-2.106-3.546-3.146 0-4.773 5.04-4.773 5.04s-2.8-3.867-4.466-3.4c-3.48 1.08-2.013 4.813.373 8.652 1.787 2.88 3.267 3.813 3.667 3.96-.014.013-.027.04-.054.053h.013c-.266.347-1.866 2.267-3.012.893-2.76-3.6-4.773-7.972-5.293-12.172-.16-1.906-.227-3.706.16-3.76.386-.052 1.493-.092 4.573-2.052 4.292-2.813 4.706-2.707 4.706-2.707s.413-.106 4.706 2.707c3.08 1.946 4.186 2 4.573 2.053.386.053.32 1.84.147 3.8-.174 1.946-1.64 9.945-10.533 17.838-1.333 1-1.186 1.133-.386 2 1.306 1.146 1.933.32 3.652-1.2 1.254-1.36 9.84-10.36 9.84-21.905 0-2.773-.507-2.346-1.867-2.8zM7.559 12.984c1.187-.013 3.173 2.32 3.24 3.107.067.373 1.013.773 1.293-.24 1.08-4.093 3.493-4.96 3.493-4.96s.96.56-.827 5.4c-.8 2.16-2.173 4.16-3.012 5.372-.094-.16-5.747-8.652-4.187-8.679z"
});

var SvgTrustLogo = function SvgTrustLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    fill: "#2741CC",
    viewBox: "0 0 24 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "5d0caff0e66e8a860f2a71f5772d906d.svg";
export { SvgTrustLogo as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/trust-logo.svg
// module id = null
// module chunks = 